import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const FORM_TCF_VENDOR_CONTEXT_SYMBOL = Symbol();
const useFormTcfVendor = ()=>useImmutableContext(FORM_TCF_VENDOR_CONTEXT_SYMBOL);
const useFormTcfVendorProvider = (...args)=>useImmutableContextProvider(FORM_TCF_VENDOR_CONTEXT_SYMBOL, ...args);
export { useFormTcfVendor, useFormTcfVendorProvider };
